import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Compliance } from '../components/Compliance';
import { About } from '../components/About';
import { PaymentCTA } from '../components/PaymentCTA';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function MarketingHome() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-red/20 selection:text-brand-navy" data-id="element-1439">
      <Navbar data-id="element-1440" />
      <main data-id="element-1441">
        <Hero data-id="element-1442" />
        <Services data-id="element-1443" />
        <WhyChooseUs data-id="element-1444" />
        <Compliance data-id="element-1445" />
        <About data-id="element-1446" />
        <PaymentCTA data-id="element-1447" />
        <Contact data-id="element-1448" />
      </main>
      <Footer data-id="element-1449" />
    </div>;
}